<template>
  <div class="hero-section" :style="backgroundStyle">
    <div class="hero-content">
      <slot name="top-menu" />
      <div class="widgets-container">
        <slot name="text-widget" />
        <slot name="media-widget" />
      </div>
      <FriedRoundedButton
        id="scroll-to-content-btn"
        data-external="scroll-to-content-button"
        @click="ContentNavigationHelper.scrollToMainFromHero"
        @mouseover="isHoveringScrollToContent = true"
        @mouseleave="isHoveringScrollToContent = false"
        @focus="isHoveringScrollToContent = true"
        @blur="isHoveringScrollToContent = false"
      >
        <template #icon>
          <FriedIcon icon="arrow-down" />
        </template>
        <template v-if="isHoveringScrollToContent">
          <slot name="scroll-button-text" />
        </template>
      </FriedRoundedButton>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ref } from 'vue';
import ContentNavigationHelper from '../../content-navigation/content-navigation.helper';

const { backgroundStyle = '' } = defineProps<{
  backgroundStyle?: string;
}>();

const isHoveringScrollToContent = ref(false);
</script>

<style scoped>
.hero-section {
  scroll-snap-align: start;
  height: calc(100vh - var(--dr-top-bar-height));
  width: 100%;

  .hero-content {
    height: 100%;
    position: relative;

    #scroll-to-content-btn {
      position: absolute;
      bottom: calc(var(--spacing-200) + var(--spacing-150));
      left: 50%;
      transform: translateX(-50%);
    }
  }
}

.widgets-container {
  display: flex;
  justify-content: center;
  gap: calc(var(--spacing-150) * 2);
}
</style>
